import React, {useEffect, useState} from "react";
import "./style.scss";
import {SMART_MOBILE_APP_IMAGES} from "../../../../../../const/WeightLossQuestionnaire";

import { Image } from "../../../../../../components/Image";
export const MobileAppGallery = () => {
    const [curIndex, setCurIndex] = useState(0);
    const [touchRange, setTouchRange] = useState(0);
    const [add, setAdd] = useState(false);

    useEffect(() => {
        const time1 = setInterval(() => {
            setAdd(true);
        }, 3000)
        return () => {
            clearInterval(time1);
        }
    }, [])
    useEffect(() => {
        if (add) {
            clickPage(curIndex+1);
            setAdd(false);
        }

    }, [add]);
    const touchStart = (e) => {
        setTouchRange(e.touches[0].pageX);
    }
    const touchEnd = (e) => {
        let count = curIndex;
        if (e.cancelable) {
            e.preventDefault();
        }
        if (touchRange - e.changedTouches[0].pageX > 50) {
            count++;
        } else if (touchRange - e.changedTouches[0].pageX < -50) {
            count--;
        }
        clickPage(count);
    }

    const clickPage = (page) => {
        let number = SMART_MOBILE_APP_IMAGES.length;
        if (page >= number) {
            page -= number;
        } else if (page < 0) {
            page += number;
        }
        setCurIndex(page);
    }

  return (
      <div className="mobile-app-gallery">
        <div className={'mobile-app-title'}>
          Improve your results with our smart mobile app
        </div>
        <div className={'mobile-app-images'}
             onTouchStart={touchStart}
             onTouchEnd={touchEnd}>
          {SMART_MOBILE_APP_IMAGES.map((value, index) => {
              let style;
              if (curIndex === index) {
                  style = {left: `calc(50% - 100px)`, width: "200px", height: "412px", zIndex: 2}
              } else if ((curIndex === 0 && index === 2) || (curIndex === 1 && index === 0) || (curIndex === 2 && index === 1)) {
                  style = {left: `calc(50% - 254px)`, width: "142px", height: "294px", zIndex: 0, opacity: 0.3}
              } else {
                  style = {left: `calc(50% + 112px)`, width: "142px", height: "294px", zIndex: 1, opacity: 0.3}
              }

            return <Image src={value} className={'mobile-app-image'} style={style} key={index} />
          })}
        </div>
        <div className="mobile-app-nav">
          <Image className="mobile-app-icon"
              alt="Icons arrow back"
              src="/static/image/questionnaire/weight-loss/payScreen/icons-arrow-back-24px.png"
              onClick={() => clickPage(curIndex - 1)} />

          <div className="mobile-app-pagination">
              {SMART_MOBILE_APP_IMAGES.map((value, index) => {
                  return <div className={curIndex === index ? "ellipse-3" : "ellipse-2"} key={index}/>
              })}
          </div>

          <Image className="mobile-app-icon"
              alt="Icons arrow back"
              src="/static/image/questionnaire/weight-loss/payScreen/icons-arrow-back-24px-1.png"
              onClick={() => clickPage(curIndex + 1)} />
        </div>
      </div>
  );
};
